import React, { useEffect, useState } from "react";
import BriefContainer from "./BriefContainer";
import { withRouter } from "react-router-dom";
import { handleException } from "../../app/util/util";
export function CaseBriefContainer(props) {
  const { userVO, chapterId } = props;
  const keepMeLogIn = localStorage.getItem("keepLoggedIn") ? "true" : "false";
  const [state, setState] = useState({
    pCaseNavtitle: "",
    pCaseSectionId: "",
    pCaseChapterId: "",
    pCaseCitation: "",
    chapterId: chapterId,
  });
  const [routeChangeMsg, setRouteChangeMsg] = useState("");
  const [chapterDrpDwnList, setChapterDrpDwnList] = useState();
  useEffect(() => {
    const initialFetchApi = async () => {
      await getCasesInBook();
    };
    initialFetchApi();
  }, []);
  const getCasesInBook = async () => {
    let reqData = {
      userVO: {
        userId: userVO.userId,
        userRole: userVO.userRole,
        userRoleId: userVO.userRoleId,
        streamContentRequiredFlag: false,
        userActivityVO: {
          lastReadPageNum: "",
          lastReadChapterId: "",
          lastReadSectionId: "",
          lastReadParagraphId: "",
          lastViewedOutlineId: "",
          lastReadSubSectionId: "",
          pageNavigatingTo: "BOOKSHELF",
          lastActivityCode: "BOOKSHELF",
          pageNavigatingFrom: "Bookshelf",
          lastReadBookId: props.bookVO.bookId,
        },
        sessionVO: {
          appType: "web",
          deviceMacId: "",
          keepMeLoggedInFlag: keepMeLogIn,
          deviceOS: localStorage.getItem("deviceOS"),
          deviceType: localStorage.getItem("deviceType"),
          browserName: localStorage.getItem("browserName"),
          sessionAuthenticationToken: userVO.sessionAuthenticationToken,
        },
      },
      bookVO: { bookId: props.bookVO.bookId },
    };
    const requestOptions1 = {
      method: "POST",
      body: JSON.stringify(reqData),
      headers: {
        "Content-Type": "application/json",
        Accept: "application/json",
      },
    };
    const data = await (
      await fetch(
        localStorage.getItem("ENV") +
          "/manageCases/getAllPrincipleCaseByBookId",
        requestOptions1,
      )
    ).json();
    if (data && data.status === "true") {
      if (data.chapterVOList) {
        data.chapterVOList = Array.isArray(data.chapterVOList)
          ? data.chapterVOList
          : [data.chapterVOList];
        data.chapterVOList.map((chaptVo) => {
          if (chaptVo.sectionVOList) {
            chaptVo.sectionVOList = Array.isArray(chaptVo.sectionVOList)
              ? chaptVo.sectionVOList
              : [chaptVo.sectionVOList];
          }
        });
        handleDefaultChapterBrief(data.chapterVOList);
        setChapterDrpDwnList(data.chapterVOList);
      }
    } else if (data.wkErrorCode) {
      handleException(data);
    }
  };
  const handleDefaultChapterBrief = (chapterVoList) => {
    var principalCasechapterVO = chapterVoList,
      paramChaptId = chapterId,
      isParamChaptId = false;
    if (paramChaptId) {
      principalCasechapterVO.map(({ chapterId, sectionVOList }) => {
        if (chapterId === paramChaptId) {
          isParamChaptId = true;
          setState({
            ...state,
            pCaseChapterId: chapterId,
            pCaseSectionId: sectionVOList[0].sectionId,
            pCaseNavtitle: sectionVOList[0].sectionTitle,
            pCaseCitation: sectionVOList[0].sectionCitation
              ? sectionVOList[0].sectionCitation
              : "",
          });
          return false;
        }
      });
      if (!isParamChaptId) {
        setState({
          ...state,
          pCaseChapterId: principalCasechapterVO[0].chapterId,
          pCaseSectionId: principalCasechapterVO[0].sectionVOList[0].sectionId,
          pCaseNavtitle:
            principalCasechapterVO[0].sectionVOList[0].sectionTitle,
          pCaseCitation: principalCasechapterVO[0].sectionVOList[0]
            .sectionCitation
            ? principalCasechapterVO[0].sectionVOList[0].sectionCitation
            : "",
        });
      }
    }
  };
  const onChangeChapterEvent = (e) => {
    let selectedChaptId =
        e.nativeEvent.target[e.nativeEvent.target.selectedIndex].attributes[
          "chapterId"
        ].value,
      selectedSectCitation =
        e.nativeEvent.target[e.nativeEvent.target.selectedIndex].attributes[
          "sectionCitation"
        ] &&
        e.nativeEvent.target[e.nativeEvent.target.selectedIndex].attributes[
          "sectionCitation"
        ].value;
    setState({
      ...state,
      chapterId: selectedChaptId,
      pCaseChapterId: selectedChaptId,
      pCaseSectionId: e.target.value,
      pCaseCitation: selectedSectCitation ? selectedSectCitation : "",
      pCaseNavtitle:
        e.nativeEvent.target[e.nativeEvent.target.selectedIndex].text,
    });
  };
  const jumpToText = (e) => {
    let history = props.history;
    let dd = document.getElementById("pCaseDropdown");
    setRouteChangeMsg(`Jumping to ${state.pCaseNavtitle} Case Briefs`);
    // 47050 - A11Y: ARIA live content is read by default instead of being conditionally triggered
    setTimeout(() => {
      // 47050 - A11Y: ARIA live content is read by default instead of being conditionally triggered
      setRouteChangeMsg("");
    }, 2000);
    if (dd.selectedOptions[0]) {
      if (
        props.match.params.chapterid ===
        dd.selectedOptions[0].getAttribute("chapterId")
      ) {
        var section = document.getElementById(dd.selectedOptions[0].value);
        if (section) {
          section.scrollIntoView();
          window.history.pushState(
            null,
            null,
            "/" +
              localStorage.getItem("reactNodeName") +
              history.location.pathname +
              "#" +
              dd.selectedOptions[0].value,
          );
          window.scroll(0, 0);
        }
        localStorage.setItem("ChapterContentFocus", "true");
        setTimeout(() => {
          localStorage.setItem("ChapterContentFocus", "false");
        }, 2000);
      } else {
        props.history.push(
          `/read/users/${userVO.userId}/books/${props.bookVO.bookISBN}/${dd.selectedOptions[0].getAttribute("chapterId")}#${dd.selectedOptions[0].value}`,
        );
        localStorage.setItem("ChapterContentFocus", "true");
      }
    }
  };
  // 47405 - A11Y: Jump to Text Selected on Focus on Case Briefs Tab
  const handleJumpToTextKeyUp = (e) => {
    // 47405 - A11Y: Jump to Text Selected on Focus on Case Briefs Tab
    if (e.key === "Enter") {
      // 47405 - A11Y: Jump to Text Selected on Focus on Case Briefs Tab
      jumpToText(e);
    }
  };
  return (
    <div className="casesList iPadMargin">
      <div className="display-inline-block viewingPort_rt mTopTen">
        <div className="display-inline-block viewingLabel_rt">Viewing</div>
        <select
          data-testid="select_chapter"
          id="pCaseDropdown"
          className="viewingInput_rt mLeftFive form-control text-box-common display-inline-block"
          value={state.pCaseSectionId}
          onChange={onChangeChapterEvent}
        >
          {chapterDrpDwnList &&
            chapterDrpDwnList.map(
              ({ navbarTitle, chapterId, sectionVOList }, key) => (
                <optgroup label={navbarTitle.split(":")[0]} key={key}>
                  {sectionVOList !== undefined &&
                    sectionVOList.map(
                      ({ sectionId, sectionCitation, sectionTitle }) => (
                        <option
                          value={sectionId}
                          sectionCitation={sectionCitation}
                          chapterId={chapterId}
                        >
                          {sectionTitle}
                        </option>
                      ),
                    )}
                </optgroup>
              ),
            )}
        </select>
        {/* 47037 - A11Y: My Notebook Case Brief note cards sections do not include heading markup */}
        {/* Original: <div className="mTopTen chapterTitle_rt">{state.pCaseNavtitle}</div> */}
        <h2 className="mTopTen chapterTitle_rt">{state.pCaseNavtitle}</h2>
        <div>
          {state.pCaseCitation && state.pCaseCitation !== "-999"
            ? state.pCaseCitation
            : ""}
        </div>
        <div className="jumbToText_rt mTopFive">
          <a
            href="javascript:void(0);"
            tabIndex="0"
            style={{ cursor: "pointer" }}
            onClick={jumpToText}
            onTouchStart={jumpToText}
            // onKeyUp={jumpToText}
            // 47405 - A11Y: Jump to Text Selected on Focus on Case Briefs Tab
            onKeyUp={handleJumpToTextKeyUp}
            onMouseUp={jumpToText}
          >
            {" "}
            Jump to Text
          </a>
        </div>
        <div
          aria-live="assertive"
          style={{ position: "absolute", left: "-9999px" }}
        >
          {routeChangeMsg}
        </div>
        <BriefContainer
          bookVO={props.bookVO}
          userVO={props.userVO}
          labelVOList={props.labelVOList}
          chapterId={state.chapterId}
          pCaseNavtitle={state.pCaseNavtitle}
          pCaseChapterId={state.pCaseChapterId}
          pCaseSectionId={state.pCaseSectionId}
        ></BriefContainer>
      </div>
    </div>
  );
}
export default withRouter(CaseBriefContainer);
